import * as constants from './actionTypes';
import { fromJS } from 'immutable';

const defaultState=fromJS({
  flag:null,
  thresholdList:[]
});

const ReducreFn=(state=defaultState,action)=>{
  switch (action.type) {
    case constants.GO:
      var flagT=state.get("flag")===null?true:!state.get("flag")
      return state.set('flag',flagT )
    case constants.THRESHOLD_LIST:
      return state.set('thresholdList',action.data )
    default:
      return state;
  }

}

export default ReducreFn